var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecharge1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 50,
    viewBox: "0 0 34 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6252 41.6668H1.37516C0.800156 41.6668 0.333496 41.2002 0.333496 40.6252C0.333496 40.0502 0.800156 39.5835 1.37516 39.5835H32.6252C33.2002 39.5835 33.6668 40.0502 33.6668 40.6252C33.6668 41.2002 33.2002 41.6668 32.6252 41.6668Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4585 50H5.5418C2.671 50 0.333496 47.6625 0.333496 44.7917V5.20833C0.333496 2.3375 2.671 0 5.5418 0H28.4585C31.3293 0 33.6668 2.3375 33.6668 5.20833V44.7917C33.6668 47.6625 31.3293 50 28.4585 50ZM5.5418 2.08333C3.8189 2.08333 2.4168 3.48542 2.4168 5.20833V44.7917C2.4168 46.5146 3.8189 47.9167 5.5418 47.9167H28.4585C30.1814 47.9167 31.5835 46.5146 31.5835 44.7917V5.20833C31.5835 3.48542 30.1814 2.08333 28.4585 2.08333H5.5418Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62572 31.2507C7.35902 31.2507 7.09242 31.1486 6.88822 30.9465C6.48192 30.5402 6.48192 29.8798 6.88822 29.4736L14.18 22.1819C14.4964 21.8632 14.9797 21.784 15.3818 21.9861L18.8777 23.734L25.6381 16.9736C26.0443 16.5674 26.705 16.5674 27.1112 16.9736C27.5175 17.3799 27.5175 18.0403 27.1112 18.4465L19.8193 25.7382C19.5006 26.0548 19.0152 26.1319 18.6172 25.934L15.1214 24.1861L8.36112 30.9465C8.15902 31.1486 7.89242 31.2507 7.62572 31.2507Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3752 24.9998C25.8002 24.9998 25.3335 24.5332 25.3335 23.9582V18.7498H20.1252C19.5502 18.7498 19.0835 18.2832 19.0835 17.7082C19.0835 17.1332 19.5502 16.6665 20.1252 16.6665H26.3752C26.9502 16.6665 27.4168 17.1332 27.4168 17.7082V23.9582C27.4168 24.5332 26.9502 24.9998 26.3752 24.9998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecharge1);
export default __webpack_public_path__ + "static/media/Recharge1.d6f2502035e39758c9063e48d83a05c3.svg";
export { ForwardRef as ReactComponent };